import deDE from "./de-DE.json";
import enUS from "./en-US.json";

export default {
  "de-DE": deDE,
  "en-US": enUS,
};
